document.addEventListener("DOMContentLoaded", () => {
    const topText = document.querySelector(".top_text");
    topText.addEventListener("click", () => {
        toggleAccordion();
    });
    window.addEventListener("resize", setAccordionHeight);
});

const toggleAccordion = () => {
    const element = document.querySelector(".cart-survey");
    const topText = document.querySelector(".top_text");
    if (element.classList.contains("active")) {
        element.style.maxHeight = topText.scrollHeight + 40 + "px";
        element.classList.remove("active");
    } else {
        element.style.maxHeight = element.scrollHeight + "px";
        element.classList.add("active");
    }
};

const setAccordionHeight = () => {
    const element = document.querySelector(".cart-survey");
    const topText = document.querySelector(".top_text");
    element.style.maxHeight = topText.scrollHeight + 40 + "px";
};
